import { safeParse } from './safeParse';
import { safeStringify } from './safeStringify';

export const jsonHelpers = {
    safeParse,
    safeStringify,
};
